import React from "react";
import { useTranslation } from "react-i18next";
import theme from "@monorepo/styles/theme";
import { EuroOutlined, Info } from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";

interface ICommissionFee {
  commission: string;
}

export const CommissionFee: React.FC<ICommissionFee> = ({ commission }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        columnGap: theme.spacing(1),
      }}
    >
      <Typography color={theme.palette.text.secondary} sx={{ paddingLeft: "3px", marginRight: "auto" }} variant="body2">
        {t("payments.commission_fee")}
      </Typography>
      <Typography variant="body2">{" " + commission}</Typography>
      <EuroOutlined sx={{ fill: theme.palette.shuttleGray.main, stroke: "none" }} fontSize="small" />
      <Tooltip title={String(t("payments.commission_fee_info"))}>
        <Info sx={{ stroke: "none", fill: theme.palette.primary.main }} />
      </Tooltip>
    </Box>
  );
};
